import { CopywriteComponent } from './lib/components/copywrite/copywrite.component';
import { DrawerFooterToolbarComponent } from './lib/components/drawer-footer-toolbar/drawer-footer-toolbar.component';
import { DrawerFooterToolbarDirective } from './lib/components/drawer-footer-toolbar/drawer-footer-toolbar.directive';
import { DrawerComponent } from './lib/components/drawer/drawer.component';
import { DrawerBodyDirective, DrawerFooterDirective } from './lib/components/drawer/drawer.directive';
import { LoadingComponent } from './lib/components/loading/loading.component';
import {
  PageHeaderToolbarButton,
  PageHeaderToolbarComponent
} from './lib/components/page-header/page-header-toolbar.component';
import { PageHeaderToolbarDirective } from './lib/components/page-header/page-header-toolbar.directive';
import { PageHeaderComponent } from './lib/components/page-header/page-header.component';
import { PageHeaderDirective } from './lib/components/page-header/page-header.directive';
import { PageMessageBoxComponent } from './lib/components/page-message-box/page-message-box.component';
import { PrefixUrlProtocolPipe } from './lib/pipes/prefix-url-protcol.pipe';

export * from './lib/view-models';

/**
 * Utility array that contains `@mri-platform/core-ui` drawer components and directives
 */
export const CORE_UI_DRAWER = [
  DrawerComponent,
  DrawerFooterToolbarComponent,
  DrawerFooterToolbarDirective,
  DrawerBodyDirective,
  DrawerFooterDirective
] as const;

/**
 * Utility array that contains all `@mri-platform/core-ui` related components and directives
 */
export const CORE_UI = [
  CopywriteComponent,
  LoadingComponent,
  PageMessageBoxComponent,
  PageHeaderComponent,
  PageHeaderDirective,
  PageHeaderToolbarDirective,
  PageHeaderToolbarComponent,
  PrefixUrlProtocolPipe,
  ...CORE_UI_DRAWER
] as const;

export {
  CopywriteComponent,
  DrawerBodyDirective,
  DrawerComponent,
  DrawerFooterDirective,
  DrawerFooterToolbarComponent,
  DrawerFooterToolbarDirective,
  LoadingComponent,
  PageHeaderComponent,
  PageHeaderDirective,
  PageHeaderToolbarComponent,
  PageHeaderToolbarDirective,
  PageMessageBoxComponent,
  PrefixUrlProtocolPipe,
  type PageHeaderToolbarButton
};
